import "./index.css";

const SrpTitleGuide = () => (
  <div className="container">
    <span className="text">Guide des tailles</span>
  </div>
);

export default SrpTitleGuide;
